import {IMyopComponent} from "../components/IMyopComponent";
import {loaderOptions} from "../hostSDK";
import {IComponentDefinitionConfig, ISkinConfig, SkinLoaderType} from "../../common";

export interface IMyopLoader {
    type: SkinLoaderType;
    load: (componentDefinition: IComponentDefinitionConfig, skin: ISkinConfig, container: HTMLElement, options?: loaderOptions) => Promise<IMyopComponent>;
}

export abstract class BaseMyopLoader implements IMyopLoader {
    abstract type: SkinLoaderType;
    abstract load: (componentDefinition: IComponentDefinitionConfig, skin: ISkinConfig, container: HTMLElement, options?: loaderOptions) => Promise<IMyopComponent>;

    appendChild = (container: HTMLElement, element: HTMLElement, options?: loaderOptions,) => {
        if (options?.relative) {
            if (options.relative.direction === 'before') {
                return container.insertBefore(element, options.relative.child);
            }

            if (options.relative.direction === 'after') {
                const nextSibling = options.relative.child?.nextSibling;
                return container.insertBefore(element, nextSibling ? nextSibling : null);
            }
        } else {
            return container.appendChild(element);
        }
    }
}
